import Vue from 'vue';
import Vuex from "vuex";


Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        tenant: null,
        documentError: "",
        isLoggedIn: false,
        isLoading: false,
        GroupID: '00000000-0000-0000-0000-000000000000',
        Scheme: {
            SchemeID: '00000000-0000-0000-0000-000000000000',
            LoanType: 0
        },
        product: {},
        userToken: null,
        user: {},
        regType: 0,
        userData: {},
        jobDetails: {},
        location: "",
        SGBList: [],
        CatList: [],
        category: "Open",
        printpmt: false,
        registrationDetails: {},
        regId: '00000000-0000-0000-0000-000000000000',
        districtId: '00000000-0000-0000-0000-000000000000',
        userDistrictId: '00000000-0000-0000-0000-000000000000',
        loanDistrict: '00000000-0000-0000-0000-000000000000',
        statusId: 1,
        LoanType: 1,
        pmtObject: {
            pmtPurpose: "",
            BoardID: '00000000-0000-0000-0000-000000000000',
            TransType: 'Registration'
        },
        applicationNo: "",
        applicationID: '00000000-0000-0000-0000-000000000000',
        lockProfile: false,
        SanctionLetter: {},
        LOIDate: null,
        appSearchForm: {},
        appList: [],
        districts: [],
        userAllowedDistricts: [], // Districts allowed for the current user based on role
        loanTypes: [],
        applicationStatusList: [],
        banks: [],
        claimStatusList: [],
        ageRangeList:[],
        amountRangeList:[],
        genderList:[{GenderID:0, Gender:"Female"}, {GenderID:1, Gender:"Male"}],
        casteList:[],
        fyList:[],
        reportQuery: [],
        reportName: "",
        minDirectors: 2,
        minCastDirectors: 2,
        StatusOwner:"All",
    },
    actions: {
        setSearchForm: function ({ commit }, searchForm) {
            commit("SET_SEARCH_FORM", searchForm);
        },
        setAppList({ commit }, AppList) {
            commit("SET_APPLIST", AppList);
        },
        lockProfile: function ({ commit }, AppStatus) {
            commit("LOCKPROFILE", AppStatus);
        },
        signup: function ({ commit }, user) {
            commit("SIGNUP", user);
        },
        login: function ({ commit }, user) {
            commit("LOGIN_SUCCESS", user);
        },
        logout: function ({ commit }) {
            commit("LOGOUT");
        },
        setRegType: function ({ commit }, regtyp) {
            commit("REGTYPE", regtyp);
        },
        setGroupID: function ({ commit }, groupId) {
            commit("GROUPID", groupId);
        },
        setApplicationNo: function ({ commit }, applicationNo) {
            commit("APPLICATIONNO", applicationNo);
        },
        setApplicationID: function ({ commit }, applicationID) {
            commit("APPLICATIONID", applicationID);
        },
        setSanctionLetter: function ({ commit }, sanctionletter) {
            commit("SANCTIONLETTER", sanctionletter);
        },
        setScheme: function ({ commit }, scheme) {
            commit("SCHEME", scheme);
        },
        setDistrict: function ({ commit }, district) {
            commit("SET_DISTRICT", district);
        },
        setLoanDistrict: function ({ commit }, district) {
            commit("SET_LOAN_DISTRICT", district);
        },
        setUserDistrict: function ({ commit }, district) {
            commit("SET_USER_DISTRICT", district);
        },
        setAppStatus: function ({ commit }, status) {
            commit("SET_APP_STATUS", status);
        },
        setLoanType: function ({ commit }, loantype) {
            commit("SET_LOAN_TYPE", loantype);
        },
        setUserData: function ({ commit }, userData) {
            commit("USERDATA", userData);
        },
        setLocation: function ({ commit }, location) {
            commit("LOCATION", location);
        },
        setJobDetails: function ({ commit }, jobData) {
            commit('SET_JOB_DETAILS', jobData);
        },
        setSGBList: function ({ commit }, sgbList) {
            commit('SET_SGB_LIST', sgbList);
        },
        setCatList: function ({ commit }, catlist) {
            commit('SET_CAT_LIST', catlist);
        },
        setFYList: function ({ commit }, fylist) {
            commit('SET_FY_LIST', fylist);
        },
        setPrintPmt: function ({ commit }, flag) {
            commit('SET_PRINT_PMT', flag);
        },
        setRegistrationDetails: function ({ commit }, data) {
            commit('SET_REGISTRATION', data);
        },
        setRegID: function ({ commit }, regId) {
            commit('SET_REGID', regId);
        },
        setPmtObject({ commit }, pmtObject) {
            commit('SET_PMTOBJ', pmtObject);
        },
        setLOIDate({ commit }, loiDate) {
            commit('SET_LOIDATE', loiDate);
        },
        setDistricts({ commit }, districts) {
            commit('SET_DISTRICTS', districts);
        },
        setUserAllowedDistricts({ commit }, districts) {
            commit('SET_USER_ALLOWED_DISTRICTS', districts);
        },
        setApplicationStatus({ commit }, applicationStatusList) {
            commit('SET_APP_STATUS_LIST', applicationStatusList);
        },
        setCasteList: function ({ commit }, castelist) {
            commit('SET_CAST_LIST', castelist);
        },
        setLoanType({ commit }, loanTypes) {
            commit('SET_LOAN_TYPE', loanTypes);
        },
        setBanks({ commit }, banks) {
            commit('SET_BANKS', banks);
        },
        setClaimStatus({ commit }, claimStatusList) {
            commit('SET_CLAIM_STATUS', claimStatusList);
        },
        setAgeRange({ commit }, ageRangeList) {
            commit('SET_AGE_RANGE', ageRangeList);
        },
        setAmountRange({ commit }, amountStatusList) {
            commit('SET_AMOUNT_RANGE', amountStatusList);
        },
        setReportQuery({ commit }, queryval) {
            commit('REPORT_QUERY', queryval);
        },
        setReportName({ commit }, reportName) {
            commit('REPORT_NAME', reportName);
        },
        setMinDirectos({ commit }, CompanyType) {
            commit('DIRECTORS_NUM', CompanyType);
        },
        setStatusOwner({ commit }, StatusOwner) {
            commit('SET_STATUS_OWNER', StatusOwner);
        },
    },
    mutations: {
        SET_DOCUMENT_ERROR(state, message) {
            state.documentError = message;
        },
        SET_TENANT(state, tenant) {
            state.tenant = tenant;
        },
        SET_SEARCH_FORM(state, SearchForm) {
            state.appSearchForm = SearchForm;
        },
        SET_APPLIST(state, AppList) {
            state.appList = AppList;
        },
        LOCKPROFILE: function (state, AppStatus) {
            state.lockProfile = AppStatus;
        },
        SIGNUP: function (state, user) {
            state.user = user.user;
        },
        LOGIN: function (state) {
            state.pending = true;
        },
        LOGIN_SUCCESS: function (state, user) {
            state.isLoggedIn = true;
            state.pending = false;
            state.userToken = user.token;
            state.user = user.user;
        },
        LOGOUT: function (state) {

            state.isLoggedIn = false;
            state.userToken = null;
            state.user = {};
        },
        REGTYPE: function (state, regtyp) {
            state.regType = regtyp;
        },
        GROUPID: function (state, groupId) {
            state.GroupID = groupId;
        },
        SCHEME: function (state, scheme) {
            state.Scheme = scheme;
        },
        SET_DISTRICT: function (state, district) {
            state.districtId = district;
        },
        SET_LOAN_DISTRICT: function (state, district) {
            state.loanDistrict = district;
        },
        SET_USER_DISTRICT: function (state, district) {
            state.userDistrictId = district;
        },
        SET_APP_STATUS: function (state, status) {
            state.statusId = status;
        },
        SET_LOAN_TYPE: function (state, loantype) {
            state.LoanType = loantype;
        },
        USERDATA: function (state, userData) {
            state.userData = userData;
        },
        LOCATION: function (state, location) {
            state.location = location;
        },
        SET_JOB_DETAILS: function (state, jobData) {
            state.jobDetails = jobData;
        },
        SET_SGB_LIST: function (state, sgbList) {
            state.SGBList = sgbList;
        },
        SET_CAT_LIST: function (state, catList) {
            state.CatList = catList;
        },
        SET_FY_LIST: function(state, fylist){
            state.fyList = fylist;
        },
        SET_PRINT_PMT: function (state, flag) {
            state.printpmt = flag;
        },
        SET_REGISTRATION: function (state, data) {
            state.registrationDetails = data;
        },
        SET_REGID: function (state, regId) {
            state.regId = regId;
        },
        SET_PMTOBJ(state, pmtObject) {
            state.pmtObject = pmtObject;
        },
        APPLICATIONNO(state, applicationNo) {
            state.applicationNo = applicationNo;
        },
        APPLICATIONID(state, applicationID) {
            state.applicationID = applicationID;
        },
        SANCTIONLETTER(state, sanctionletter) {
            if (sanctionletter && parseFloat(sanctionletter.ROI) > 12) {
                sanctionletter.ROI = 12;
            }
            state.SanctionLetter = sanctionletter;
        },
        SET_LOIDATE: (state, loiDate) => {
            state.LOIDate = loiDate;
        },
        SET_DISTRICTS: (state, districts) => {
            state.districts = districts;
        },
        SET_USER_ALLOWED_DISTRICTS: (state, districts) => {
            state.userAllowedDistricts = districts;
        },
        SET_APP_STATUS_LIST: (state, applicationStatusList) => {
            state.applicationStatusList = applicationStatusList
        },
        SET_CAST_LIST:(state, castelist)=>{
            state.casteList = castelist;
        },
        SET_LOAN_TYPE: (state, loanTypes) => {
            state.loanTypes = loanTypes
        },
        SET_BANKS: (state, banks) => {
            state.banks = banks;
        },
        SET_CLAIM_STATUS: (state, claimStatusList) => {
            state.claimStatusList = claimStatusList;
        },
        SET_AGE_RANGE: (state, ageRangeList)=>{
            state.ageRangeList = ageRangeList;
        },
        SET_AMOUNT_RANGE: (state, amountRangeList)=>{
            state.amountRangeList = amountRangeList;
        },
        REPORT_QUERY(state, queryval) {
            state.reportQuery = queryval;
        },
        REPORT_NAME(state, reportName) {
            state.reportName = reportName;
        },
        DIRECTORS_NUM(state, companyType) {
            state.minCastDirectors = companyType.MinCastDirectors;
            state.minDirectors = companyType.MinDirectorsRequired;
        },
        SET_STATUS_OWNER(state, StatusOwner){
            state.StatusOwner = StatusOwner;
        }
    },
    getters: {
        lockProfile: state => {
            return state.lockProfile;
        },
        isLoggedIn: state => {
            return state.isLoggedIn;
        },
        authToken: state => {
            return state.userToken;
        },
        loggedUser: state => {
            return state.user;
        },
        getGroupId: state => {
            return state.GroupID;
        },
        getScheme: state => {
            return state.Scheme;
        },
        getJobDetails: state => {
            return state.jobDetails;
        },
        getLocation: state => {
            return state.location;
        },
        getRegTyp: state => {
            return state.regType
        },
        getUserData: state => {
            return state.userData
        },
        UserName: state => {
            return state.user.UserName;
        },
        isLoading: state => {
            return state.isLoading;
        },
        getSGBList: state => {
            return state.SGBList;
        },
        getCatList: state => {
            return state.CatList;
        },
        getPrintPmt: state => {
            return state.printpmt;
        },
        getRegistrationDetails: state => {
            return state.registrationDetails;
        },
        getRegId: state => {
            return state.regId;
        },
        getPmtObj: state => {
            return state.pmtObject;
        },
        getDistrict: state => {
            return state.districtId;
        },
        getLoanDistrict: state => {
            return state.loanDistrict;
        },
        getUserDistrict: state => {
            return state.userDistrictId;
        },
        getAppStatus: state => {
            return state.statusId;
        },
        getLoanType: state => {
            return state.LoanType;
        },
        getApplicationID: state => {
            return state.applicationID;
        },
        getSanctionLetter: state => {
            return state.SanctionLetter;
        },
        getLOIDate: state => {
            return state.LOIDate;
        },
        getAppSearchForm: state => {
            return state.appSearchForm;
        },
        getDynamicValues: state => param => {
            return state[param];
        },
        getdistricts: state => {

            return state.districts;
        },
        getUserAllowedDistricts: state => {
            return state.userAllowedDistricts;
        },
        getapplicationStatusList: state => {
            return state.applicationStatusList;
        },
        getloanTypes: state => {
            return state.loanTypes;
        },
        getbanks: state => {
            return state.banks;
        },
        getclaimStatusList: state => {
            return state.claimStatusList;
        },
        getReportQuery: state => {
            return state.reportQuery;
        },
        getReportName: state => {
            return state.reportName;
        },
        getDirectorNum: state => {
            return { directors: state.minDirectors, casteDirectors: state.minCastDirectors };
        },
        getStatusOwner: state=>{
            return state.StatusOwner;
        }
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js